import { nativeBridgePresent } from "@/platform/nativeBridge";
import { replacePlatform } from "@/platform";

/** Call before React render. No-op in the browser and PWA. */
export async function bootPlatform(): Promise<void> {
  if (!nativeBridgePresent()) return;
  document.documentElement.classList.add("native-shell");
  const { createCapacitorPlatform, startCapacitorChrome } = await import(
    "@/platform/capacitor/createCapacitorPlatform"
  );
  replacePlatform(createCapacitorPlatform());
  await startCapacitorChrome();
}
